import axiosHttp from "services/axiosHttp";

// Budget Service Functions
export const budgetService = {
  // Upsert (Create or Update) budget line
  // POST /pmo/portfolio-budget/line
  upsertBudgetLine: async (data) => {
    const response = await axiosHttp.post("/pmo/portfolio-budget/line", data);
    return response.data;
  },

  // Delete budget line
  // POST /pmo/portfolio-budget/line/:id/delete
  deleteBudgetLine: async ({ id, data }) => {
    const response = await axiosHttp.post(`/pmo/portfolio-budget/line/${id}/delete`, data);
    return response.data;
  },

  // Get budget for a portfolio
  // GET /pmo/portfolio-budget/:portfolio_id?year=2025
  getBudget: async (portfolioId, year) => {
    const response = await axiosHttp.get(`/pmo/portfolio-budget/${portfolioId}`, {
      params: { year }
    });
    return response.data;
  }
};

